import React, { useEffect, useState } from "react";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { motion } from "framer-motion";
import axios from "axios";
import Images from "../utils/Images";
import { API } from "../utils/Api";

import LocationOnRoundedIcon from "@mui/icons-material/LocationOnRounded";
import KeyboardArrowDownRoundedIcon from "@mui/icons-material/KeyboardArrowDownRounded";

const Header = ({ outletData = null, canAnimate = true }) => {
  const [outletName, setOutletName] = useState(
    outletData?.name || "Xpanse Cafe",
  );

  const outletAddress =
    outletData?.address || "Your favourite food and beverages";

  useEffect(() => {
    const outletId = outletData?._id;

    if (!outletId) {
      setOutletName(outletData?.name || "Xpanse Cafe");
      return undefined;
    }

    if (outletData?.name) {
      setOutletName(outletData.name);
    }

    let cancelled = false;

    const fetchOutletName = async () => {
      try {
        const response = await axios.get(
          `${API.BASE_URL}outlet/getOutletCityPincode`,
        );

        const records = [
          ...(response?.data?.data?.totalOutletRecords || []),
          ...(response?.data?.data?.comingSoonOutlets || []),
        ];

        const matchedOutlet = records.find(
          (outlet) => outlet?._id === outletId,
        );

        if (!cancelled && matchedOutlet?.name) {
          setOutletName(matchedOutlet.name);
        }
      } catch (error) {
        console.error(
          "Error fetching outlet name:",
          error?.response?.data || error,
        );
      }
    };

    fetchOutletName();

    return () => {
      cancelled = true;
    };
  }, [outletData?._id, outletData?.name]);

  const hidden = { opacity: 0, y: -15 };
  const visible = { opacity: 1, y: 0 };

  return (
    <Box
      component={motion.div}
      initial={hidden}
      animate={canAnimate ? visible : hidden}
      transition={{
        duration: 0.45,
        ease: "easeOut",
      }}
      sx={{
        position: "relative",
        overflow: "hidden",
        px: {
          xs: 2,
          sm: 2.5,
        },
        py: {
          xs: 2,
          sm: 2.4,
        },
        // pb: {
        //   xs: 5.5,
        //   sm: 7,
        // },
        color: "#1F2937",
        backgroundColor: "#09A5F7",
        boxShadow: "0 10px 28px rgba(54, 179, 255, 0.18)",
        borderRadius: {
          xs: "0 0 28px 28px",
          sm: "0 0 34px 34px",
        },
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={2}
        sx={{
          position: "relative",
          zIndex: 1,
        }}
      >
        <img
          src={Images.xpanse4}
          alt="Xpanse Cafe"
          sx={{
            flexShrink: 0,
            width: "100%",
            height: "100%",
            objectFit: "contain",
            p: 0.5,
          }}
        />

        <Box
          sx={{
            position: "relative",
            zIndex: 1,
            mt: 1.5,
            p: 1,
            border: "1px solid rgba(31, 41, 55, 0.12)",
            borderRadius: 55,
            background: "#fff",
            backdropFilter: "blur(10px)",
            WebkitBackdropFilter: "blur(10px)",
          }}
        >
          <Stack direction="row" alignItems="center" spacing={0.5}>
            <LocationOnRoundedIcon
              sx={{
                fontSize: 17,
                color: "#09A5F7",
              }}
            />

            <Box>
              <Typography
                component="span"
                sx={{
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#0E4961",
                }}
              >
                {outletName}
              </Typography>
            </Box>
          </Stack>
        </Box>
      </Stack>
    </Box>
  );
};

export default Header;
